import { Divider, List, ListItem, makeStyles, Typography } from "@material-ui/core";
import React, { cloneElement } from "react";
import {
    ReferenceManyFieldProps,
    useQuery,
    useRecordContext
} from "react-admin"


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

interface ReferenceManyInputProps extends ReferenceManyFieldProps {
    getMany?: boolean;
}

const ReferenceManyInput = (props: ReferenceManyInputProps) => {
    const classes = useStyles()

    const {
        basePath,
        children,
        filter,
        // page = 1,
        perPage,
        reference,
        resource,
        sort,
        // source,
        target,
        getMany = false,
    } = props;
    const record = useRecordContext(props);

    if (React.Children.count(children) !== 1) {
        throw new Error(
            '<ReferenceManyField> only accepts a single child (like <Datagrid>)'
        );
    }


    // console.log(reference, record.id)
    const { loaded, error, data } = useQuery({
        type: getMany ? 'getMany' : 'getManyReference',
        resource: reference,
        payload: { target, id: record.id, ids: [record.id], filter, perPage, sort, }
    });
    // console.log(reference, target, data)

    if (!loaded)
        return null

    if (error)
        return <Typography>{error}</Typography>


    return <List component="ul" aria-label="main list" className={classes.root}>
        {
            data.map((record: any, index: number) => {
                return <>
                    <ListItem>
                        {cloneElement(children, {
                            basePath,
                            record,
                            // redirect,
                            resource,
                            // save,
                            // saving,
                            // version,
                        })}
                    </ListItem>
                    {(index !== data.length - 1) && <Divider component="li" />}
                </>
            })
        }
    </List >
}


export default ReferenceManyInput